<template>
  <div>
    <ll-input
      v-model:value="innerValue"
      v-bind="getBindValue"
      :disabled="props.disabled"
      :class="bem.m('click-input')"
    >
      <template #suffix>
        <ll-button type="link" :disabled="props.disabled" @click="handleClick">
          <ll-icon style="font-size: 16px" icon-name="icon-amplify2" />
        </ll-button>
      </template>
    </ll-input>
    <api-modal
      v-model:value="innerValue"
      v-model:open="open"
      :type="props.type"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, useAttrs, watch, computed } from 'vue'

import { omit } from 'lodash-es'

import { createNamespace } from '@ll-plus/utils'

import { clickInputProps, clickInputEmits } from '../config'

import ApiModal from './api-modal.vue'

defineOptions({ name: 'LlClickInput' })

const bem = createNamespace('api-component')

const props = defineProps(clickInputProps)

const emits = defineEmits(clickInputEmits)

const attrs = useAttrs()

const innerValue = ref(props.value)

const open = ref(false)

const getBindValue = computed(() => {
  return omit({ ...attrs }, ['value'])
})

const handleClick = () => {
  if (attrs.disabled) return
  open.value = true
}

watch(innerValue, n => {
  emits('update:value', n)
})
</script>
